var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mortgagegold",
      on: {
        click: function($event) {
          return _vm.isDo()
        }
      }
    },
    [
      _c("van-nav-bar", {
        attrs: {
          title: "存料",
          "safe-area-inset-top": "",
          fixed: "",
          "left-arrow": "",
          placeholder: "",
          border: false
        },
        on: { "click-left": _vm.onClickLeft }
      }),
      _c(
        "div",
        { staticClass: "rel" },
        [
          _c("center", { staticClass: "boxgoldprice" }, [
            _c("h2", [_vm._v(_vm._s(_vm.pricebox))]),
            _c("div", { staticClass: "pricebox" }, [
              _vm._v(_vm._s(_vm.initCity))
            ])
          ]),
          _c("div", { staticClass: "bottombox" }, [
            _c(
              "div",
              { staticClass: "userselect" },
              [
                _c("van-cell", {
                  attrs: {
                    title: "订单类型",
                    value: _vm.initCity,
                    size: "large"
                  }
                }),
                _c("van-cell", {
                  attrs: {
                    title: "快递费",
                    value: _vm.userInfo.expressFee,
                    size: "large"
                  }
                }),
                _c("van-cell", {
                  attrs: {
                    title: "保险费",
                    value: _vm.userInfo.insuranceFee,
                    size: "large"
                  }
                }),
                _c("van-cell", {
                  attrs: {
                    title: "首饰折价",
                    value: _vm.userInfo.purificationFee,
                    size: "large"
                  }
                }),
                _c("div", { staticClass: "title_box " }, [
                  _c(
                    "div",
                    { staticClass: "flex-between weightbox" },
                    [
                      _c("span", [
                        _vm._v("重量 "),
                        _c("i", { staticClass: "dingJIn" }, [
                          _vm._v("(可存克重 "),
                          _c("span", { staticClass: "dingJinData" }, [
                            _vm._v(_vm._s(_vm.userInfo.goldIncomingFreeWeight))
                          ]),
                          _vm._v(" )")
                        ])
                      ]),
                      _c("el-input", {
                        class: _vm.isinput ? "yellowfont" : "",
                        attrs: {
                          placeholder: "0",
                          type: "number",
                          maxlength: "6"
                        },
                        on: { input: _vm.handleInput2 },
                        model: {
                          value: _vm.weight,
                          callback: function($$v) {
                            _vm.weight = $$v
                          },
                          expression: "weight"
                        }
                      }),
                      _c("div", { staticClass: "unit" }, [_vm._v("克")])
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "title_box " }, [
                  _c("div", { staticClass: "flex-between weightbox" }, [
                    _c("span", [_vm._v("预收金额")]),
                    _c(
                      "div",
                      {
                        staticClass: "countMumber",
                        style: { color: _vm.isinput ? "#242424" : "#D1D1D1" }
                      },
                      [_vm._v(" " + _vm._s(_vm.countMumber) + " ")]
                    ),
                    _c("div", { staticClass: "unit" }, [_vm._v("元")])
                  ])
                ])
              ],
              1
            )
          ]),
          _c(
            "div",
            {
              staticClass: "btnbox",
              style: { background: Number(_vm.weight) ? "#ff2d2e" : "#f7cdcd" },
              on: {
                click: function($event) {
                  return _vm.postData("showpop")
                }
              }
            },
            [_vm._v(" 立即存料 ")]
          ),
          _c("div", { staticClass: "tipBox" }, [
            _vm._m(0),
            _c("div", { domProps: { innerHTML: _vm._s(_vm.mortgageTips) } })
          ]),
          _c(
            "van-dialog",
            {
              model: {
                value: _vm.showorder,
                callback: function($$v) {
                  _vm.showorder = $$v
                },
                expression: "showorder"
              }
            },
            [
              _c("div", { staticClass: "title" }, [_vm._v("订单确认")]),
              _c("div", { staticClass: "confirmCenterbox_dialog" }, [
                _c("div", { staticClass: "flex orderInfo" }, [
                  _c("div", { staticClass: "orderCol" }, [_vm._v("订单类型")]),
                  _c("div", [_vm._v(_vm._s(_vm.initCity) + "实物")])
                ]),
                _c("div", { staticClass: "flex orderInfo" }, [
                  _c("div", { staticClass: "orderCol" }, [_vm._v("重量")]),
                  _c("div", [_vm._v(_vm._s(_vm.weight) + "g")])
                ]),
                _c("div", { staticClass: "flex orderInfo" }, [
                  _c("div", { staticClass: "orderCol" }, [_vm._v("初始单价")]),
                  _c("div", [
                    _c("span", { staticStyle: { color: "#FF4B71" } }, [
                      _vm._v(_vm._s(_vm.pricebox))
                    ]),
                    _vm._v(" 元/克 ")
                  ])
                ]),
                _c("div", { staticClass: "flex orderInfo" }, [
                  _c("div", { staticClass: "orderCol" }, [_vm._v("预收金额")]),
                  _c("div", [_vm._v(_vm._s(_vm.countMumber) + "元")])
                ])
              ]),
              _c("div", { staticClass: "autograph" }, [
                _c("div", { staticClass: "autographText" }, [
                  _vm._v("手写签名")
                ]),
                _c("div", { staticClass: "autographBox" }, [
                  _vm.img
                    ? _c("img", { attrs: { src: _vm.img, alt: "" } })
                    : _vm._e()
                ])
              ]),
              _c("div", { staticClass: "flex popbtn" }, [
                _c(
                  "div",
                  {
                    staticClass: "gocer closebtn",
                    on: { click: _vm.closepop }
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "gocer confirmbtn",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.postData("postDataf")
                      }
                    }
                  },
                  [_vm._v(" 确定 ")]
                )
              ])
            ]
          ),
          _c(
            "van-dialog",
            {
              staticClass: "ceringModel",
              model: {
                value: _vm.ceringModel,
                callback: function($$v) {
                  _vm.ceringModel = $$v
                },
                expression: "ceringModel"
              }
            },
            [
              _c("div", { staticClass: "title" }, [_vm._v("提示")]),
              _c("div", { staticClass: "centerbox_dialog" }, [
                _vm._v(_vm._s(_vm.stopMiniTrading))
              ]),
              _c(
                "div",
                {
                  staticClass: "confirm",
                  on: {
                    click: function($event) {
                      _vm.ceringModel = false
                    }
                  }
                },
                [_vm._v("我知道了")]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _vm._v(" 温馨提示 "),
      _c("div", { staticClass: "leftLine" }),
      _c("div", { staticClass: "rightLine" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }